export default {
    protein: [
        { id: "101", name: "🍗 Куряче філе", energy: 120 },
        { id: "102", name: "🐷 Свиняч Вирізка", energy: 150 },
        { id: "103", name: "🥩 Телячий Гуляш (пісне)", energy: 140 },
        { id: "104", name: "🦃 Індичка (пісне)", energy: 90 },
        { id: "105", name: "🐟 Риба Хек", energy: 90 },
        { id: "106", name: "🐟 Оселедець (слабосолений)", energy: 180 },
        { id: "107", name: "🍳 Яйця", energy: 155 },
        { id: "108", name: "🥛 Молоко", energy: 42 },
        { id: "109", name: "🍚 Сир кисломолочний", energy: 100 },
        { id: "110", name: "🍼 Кефір", energy: 40 },
        { id: "111", name: "Мойва смажена : б17 14грн", energy: 221 },
        { id: "112", name: "Лазанья м'ясна : б10 14грн", energy: 273 },
        { id: "113", name: "Крильця курячі «Баффало» : б25 16грн", energy: 245 },
        { id: "121", name: "Четвертина куряча на дровах : б16 16грн", energy: 125},
        { id: "114", name: "Хек тушка під маринадом : б18 17грн", energy: 190 },
        { id: "115", name: "Рулет рибний : б14 17грн", energy: 154 },
        { id: "116", name: "Печінка по-королівськи : б22 18грн", energy: 292 },
        { id: "117", name: "Стегно куряче на дровах : б13 19грн", energy: 142 },
        { id: "118", name: "Скумбрія філе гриль : б22 20грн", energy: 220 },
        { id: "119", name: "Горбуша гріль : б25 21грн", energy: 155 },
        { id: "120", name: "Биток курячий ніжний : б21 22грн", energy: 358 },
    ],
    grocery: [
        { id: "201", name: "Ячмінка", energy: 300 },
        { id: "202", name: "Пшенична", energy: 295 },
        { id: "203", name: "Пшоно", energy: 325 },
        { id: "205", name: "Вівсяні пластівці", energy: 360 },
        { id: "211", name: "Кукурудза", energy: 310 },
        { id: "206", name: "Макарони з твердої пшениці", energy: 325 },
        { id: "207", name: "Макарони коричневі (цільнозернові)", energy: 315 },
        { id: "204", name: "Горох", energy: 285 },
        { id: "208", name: "Сочевиця", energy: 280 },
        { id: "209", name: "Квасоля", energy: 150 },
        { id: "210", name: "Гречка", energy: 325 },
        { id: "219", name: "Морква по-корейськи : б2 ц9грн", energy: 63 },
        { id: "219", name: "Бурячок тертий : б19 ц10грн", energy: 165 },
        { id: "219", name: "Капуста Пелюстки : б2 ц10", energy: 23 },
        { id: "219", name: "Салат з капусти з зеленню : б2 ц13грн", energy: 107 },
        { id: "219", name: "Салат вінегрет : б2 ц14", energy: 106 },
        { id: "211", name: "Холодець домашній : б10 ц14грн", energy: 180 },
        { id: "212", name: "Капуста тушкована з м'ясом : б18 ц15грн", energy: 161 },
        { id: "213", name: "Зрази картопляні з капустою : б5 ц15грн", energy: 297 },
        { id: "214", name: "Голубці з м'ясом та рисом у соусі : б6 ц15грн", energy: 191 },
        { id: "215", name: "Банош з бринзою : б4 ц16грн", energy: 185 },
        { id: "216", name: "Плов із куркою : б10 ц17грн", energy: 255 },
        { id: "217", name: "Овочі по-китайськи : б2 ц20", energy: 161 },
        { id: "218", name: "Сирники : б8 ц24грн", energy: 209 },
    ],
    omegaFats: [
        { id: "306", name: "🧴 Оливкова або Лляна Олія", energy: 900 },
        { id: "301", name: "🥜 Горіхи", energy: 630 },
        { id: "302", name: "🍤 Мідії", energy: 300 },
        { id: "303", name: "🌿 Морська капуста", energy: 40 },
        { id: "304", name: "🥑 Авокадо", energy: 250 },
        { id: "305", name: "🍫 Шоколад", energy: 510 },
    ],
    tasty: [
        { id: "401", name: "🧈 Сирок плавлений", energy: 220 },
        { id: "402", name: "🧀 Сир твердий", energy: 350 },
        { id: "403", name: "🌭 Сосиски слабожирні", energy: 240 },
        { id: "404", name: "🌭 Сосиски сильно жирні", energy: 305 },
        { id: "405", name: "🍞 Хліб без олії", energy: 240 },
        { id: "408", name: "🍞 Хліб з олією", energy: 310 },
        { id: "406", name: "🥓 Свиняча очеревина", energy: 900 },
        { id: "407", name: "🍕 Піцца", energy: 280 },
        { id: "409", name: "🍏 Яблука", energy: 46 },
        { id: "410", name: "🍝 Мівіна", energy: 400 },
        { id: "411", name: "Цукор", energy: 410 },
        { id: "412", name: "Млинці з яблуками : 9грн", energy: 209 },
        { id: "413", name: "Млинці з куркою та морквою по-корейськи : 10грн", energy: 255 },
        { id: "414", name: "Налисники : 11грн", energy: 283 },
        { id: "415", name: "Млинці з сиром : 13грн", energy: 261 },
        { id: "416", name: "Оселедець під шубою : 15грн", energy: 214 },
        { id: "417", name: "Млинці з шинкою та сиром : 15грн", energy: 296 },
        { id: "418", name: "Салат олів'є : 18грн", energy: 202 },
        { id: "419", name: "Салат «Ніжність» : 20грн", energy: 217 },
        { id: "420", name: "Салат «Пігмаліон» : 20грн", energy: 205 },
    ],
};
